<div *ngIf="formStageEmployee && editorReady" class="main-content profile-editor-page project-admin-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ pageTitle }}</h1>
      </div>
      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="onNoClick()">
          Regresar
        </button>
        <button *ngIf="!modeEditable" type="button" class="app-form-btn app-form-btn--secondary" (click)="clear()">
          Limpiar
        </button>
        <button *ngIf="nuevoAlcanceBtnOculto" type="button" class="app-form-btn app-form-btn--secondary"
          (click)="abrirModalParaAgregarNuevoAlcance(data)">
          Nuevo alcance
        </button>
        <button type="button" class="app-form-btn app-form-btn--primary" (click)="save()"
          [disabled]="!formStageEmployee.valid">
          Guardar {{ entityLabel | lowercase }}
        </button>
      </div>
    </section>

    <section class="profile-editor-page__card project-admin-editor-page__card">
      <div class="profile-editor-page__card-body">
        <div class="project-admin-editor-page__legacy-shell">
          <form [formGroup]="formStageEmployee" autocomplete="off">
            <div class="project-admin-editor-page__wizard-nav" role="tablist" aria-label="Flujo de captura">
              <button *ngFor="let wizardStep of wizardSteps" type="button"
                class="project-admin-editor-page__wizard-step" [class.is-active]="step === wizardStep.index"
                [class.is-complete]="step > wizardStep.index" [class.is-enabled]="canAccessStep(wizardStep.index)"
                [disabled]="!canAccessStep(wizardStep.index)" (click)="goToStep(wizardStep.index)">
                <span class="project-admin-editor-page__wizard-step-index">{{ wizardStep.index + 1 }}</span>
                <span class="project-admin-editor-page__wizard-step-copy">
                  <strong>{{ wizardStep.label }}</strong>
                  <small>{{ wizardStep.description }}</small>
                </span>
              </button>
            </div>

            <div class="project-admin-editor-page__panel-stack">
              <mat-expansion-panel *ngIf="step === 0" expanded hideToggle
                class="project-admin-editor-page__wizard-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ data.tipo === "PROYECTO" ? "Proyecto" : "Servicio" }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{
                        data.tipo === "PROYECTO"
                        ? "Detalles del proyecto"
                        : "Detalles del servicio"
                        }}
                        <mat-icon>category</mat-icon>
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="row project-admin-editor-page__form-grid">
                      <div class="col-md-3 col-xl-3">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Tipo</mat-label>
                          <mat-select formControlName="tipo" [(ngModel)]="data.tipo" (selectionChange)="onChangeTipo()">
                            <mat-option *ngFor="let option of tipoOpciones" [value]="option">{{ option }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="col-md-6 col-xl-6">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>{{
                            data.tipo === "PROYECTO"
                            ? "Nombre del proyecto:"
                            : "Nombre del servicio:"
                            }}</mat-label>
                          <input cdkFocusInitial matInput #nameProjectCtrl [(ngModel)]="data.nombre"
                            formControlName="nameProjectCtrl" maxlength="150"
                            [attr.aria-label]="data.tipo === 'PROYECTO' ? 'Nombre del proyecto:' : 'Nombre del servicio:'"
                            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)" />
                          <mat-error *ngIf="
                          formStageEmployee.controls.nameProjectCtrl.invalid &&
                          (formStageEmployee.controls.nameProjectCtrl.dirty ||
                            formStageEmployee.controls.nameProjectCtrl
                              .touched) &&
                          formStageEmployee.controls.nameProjectCtrl.errors
                            .required
                            ">
                            Campo requerido..</mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-md-3 col-xl-3">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Nombre corto:</mat-label>
                          <input matInput formControlName="nameProjectShortCtrl" [(ngModel)]="data.nombre_corto"
                            maxlength="45" aria-label="Nombre corto:"
                            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)" />
                          <mat-error *ngIf="
                          formStageEmployee.controls.nameProjectShortCtrl
                            .invalid &&
                          (formStageEmployee.controls.nameProjectShortCtrl
                            .dirty ||
                            formStageEmployee.controls.nameProjectShortCtrl
                              .touched) &&
                          formStageEmployee.controls.nameProjectShortCtrl.errors
                            .required
                            ">
                            Campo requerido..</mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-md-8 col-lg-8">
                        <div
                          class="project-admin-editor-page__field-shell project-admin-editor-page__field-shell--action">
                          <div class="project-admin-editor-page__field-main">
                            <mat-form-field appearance="outline" class="profile-editor-page__field">
                              <mat-label>Cliente:</mat-label>
                              <mat-select formControlName="customerCtrl" [(ngModel)]="data.idCliente"
                                (selectionChange)="seleccionCliente($event)">
                                <mat-option *ngFor="let cliente of clientes" [value]="cliente.id">
                                  {{ cliente.razonsocial }}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="
                              formStageEmployee.controls.customerCtrl.invalid &&
                              (formStageEmployee.controls.customerCtrl.dirty ||
                                formStageEmployee.controls.customerCtrl
                                  .touched) &&
                              formStageEmployee.controls.customerCtrl.errors
                                .required
                                ">
                                Campo requerido..</mat-error>
                            </mat-form-field>
                          </div>
                          <button *ngIf="!data.idCliente" type="button" class="project-admin-editor-page__field-action"
                            mat-icon-button matTooltip="Agregar cliente" [matTooltipPosition]="'above'"
                            (click)="agregarCliente()" aria-label="Agregar cliente">
                            <mat-icon>mode_edit</mat-icon>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-8 col-lg-4">
                        <div
                          class="project-admin-editor-page__field-shell project-admin-editor-page__field-shell--action">
                          <div class="project-admin-editor-page__field-main">
                            <mat-form-field appearance="outline" class="profile-editor-page__field">
                              <mat-label>Área:</mat-label>
                              <mat-select formControlName="areaProjectCtrl" [(ngModel)]="data.idArea">
                                <mat-option value="option" *ngFor="let areaObject of listArea"
                                  [value]="areaObject.id">{{
                                  areaObject.area }}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="
                              formStageEmployee.controls.areaProjectCtrl
                                .invalid &&
                              (formStageEmployee.controls.areaProjectCtrl
                                .dirty ||
                                formStageEmployee.controls.areaProjectCtrl
                                  .touched) &&
                              formStageEmployee.controls.areaProjectCtrl.errors
                                .required
                                ">
                                Campo requerido..</mat-error>
                            </mat-form-field>
                          </div>
                          <button type="button" class="project-admin-editor-page__field-action" mat-icon-button
                            matTooltip="Agregar área" [matTooltipPosition]="'above'" (click)="agregarArea()"
                            aria-label="Agregar área">
                            <mat-icon>mode_edit</mat-icon>
                          </button>
                        </div>
                      </div>
                      <div class="col-6" *ngIf="!idGeneradoExito && idClienteRelacionado != null">
                        <div class="project-admin-editor-page__aux-toggle-row">
                          <div class="project-admin-editor-page__aux-copy project-admin-editor-page__aux-copy--toggle">
                            <p>Registrar un producto nuevo.</p>
                          </div>
                          <mat-checkbox class="project-admin-editor-page__aux-toggle"
                            [checked]="esNuevoProducto === true" matTooltip="Agregar nuevo producto"
                            (change)="nuevoProducto($event)">
                          </mat-checkbox>
                        </div>
                      </div>
                      <div class="col-md-4 project-admin-editor-page__project-summary" *ngIf="idGeneradoExito">
                        <div class="project-admin-editor-page__aux-card">
                          <div class="project-admin-editor-page__aux-copy">
                            <span class="project-admin-editor-page__aux-label">ID proyecto</span>
                            <strong>{{ idProyectoEt }}</strong>
                            <p>Identificador asignado automaticamente.</p>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6" *ngIf="!idGeneradoExito">
                        <mat-form-field appearance="outline" class="profile-editor-page__field"
                          *ngIf="esNuevoProducto">
                          <mat-label>Nuevo producto</mat-label>
                          <input matInput formControlName="nombreProducto" maxlength="45" name="nombreProducto"
                            class="project-admin-editor-page__uppercase-input" aria-label="Nuevo producto" />
                          <button type="button" mat-icon-button matSuffix color="primary"
                            class="project-admin-editor-page__field-suffix-action" *ngIf="
                          this.formStageEmployee.get('nombreProducto')
                            .value != ''
                            " (click)="guardaProducto()" aria-label="Guardar producto">
                            <mat-icon>add_circle</mat-icon>
                          </button>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="profile-editor-page__field"
                          *ngIf="!esNuevoProducto && listProducto.length > 0">
                          <mat-label>Seleccionar producto</mat-label>
                          <mat-select (selectionChange)="seleccionarProducto($event)" formControlName="productoCtrl"
                            [(ngModel)]="idProductoSelect">
                            <mat-option *ngFor="let prod of listProducto" [value]="prod.id_producto">{{ prod.producto
                              }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="col-12 project-admin-editor-page__schedule-row">
                        <div class="row">
                          <div class="col-12 col-md-4" *ngIf="!idGeneradoExito">
                            <mat-form-field appearance="outline" class="profile-editor-page__field">
                              <mat-label>Seleccionar servicio</mat-label>
                              <mat-select (selectionChange)="seleccionarServicio($event)" formControlName="servicioCtrl"
                                [(ngModel)]="data.servicio">
                                <mat-option *ngFor="let servicio of listServicios" [value]="servicio.id">{{
                                  servicio.descripcion }}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="
                              formStageEmployee.get('servicioCtrl')?.invalid &&
                              formStageEmployee.get('servicioCtrl')?.touched
                                ">
                                Campo requerido.
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-12 col-md-4">
                            <mat-form-field appearance="outline" class="profile-editor-page__field">
                              <mat-label>Fecha de inicio:</mat-label>
                              <input matInput formControlName="dateStartCtrl" [matDatepicker]="dateStart"
                                [(ngModel)]="data.fechaInicio" readonly aria-label="Fecha de inicio:" />
                              <mat-datepicker-toggle matSuffix [for]="dateStart"></mat-datepicker-toggle>
                              <mat-datepicker #dateStart></mat-datepicker>
                              <mat-error *ngIf="
                              formStageEmployee.get('dateStartCtrl').invalid &&
                              (formStageEmployee.get('dateStartCtrl').dirty ||
                                formStageEmployee.get('dateStartCtrl').touched) &&
                              formStageEmployee.get('dateStartCtrl').errors.required
                                ">
                                Campo requerido.
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-12 col-md-4">
                            <mat-form-field appearance="outline" class="profile-editor-page__field">
                              <mat-label>Fecha de fin:</mat-label>
                              <input matInput formControlName="dateEndCtrl" [matDatepicker]="dateEnd"
                                [(ngModel)]="data.fechaFin" (dateChange)="validarDias()" readonly aria-label="Fecha de fin:" />
                              <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
                              <mat-datepicker #dateEnd></mat-datepicker>
                              <mat-error *ngIf="
                              formStageEmployee.controls.dateEndCtrl.invalid &&
                              (formStageEmployee.controls.dateEndCtrl.dirty ||
                                formStageEmployee.controls.dateEndCtrl.touched) &&
                              formStageEmployee.controls.dateEndCtrl.errors.required
                                ">
                                Campo requerido.
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Descripción:</mat-label>
                          <textarea maxlength="500" matInput formControlName="descriptionProjectCtrl"
                            [(ngModel)]="data.descripcion" aria-label="Descripción:"
                            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                        </mat-form-field>
                      </div>

                      <div class="col-md-6">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Requerimientos:</mat-label>
                          <textarea maxlength="500" matInput formControlName="requerimiento"
                            [(ngModel)]="data.requerimiento" aria-label="Requerimientos:"
                            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                        </mat-form-field>
                      </div>

                      <div class="col-md-6">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Observaciones:</mat-label>
                          <textarea maxlength="500" matInput formControlName="observaciones"
                            [(ngModel)]="data.observaciones" aria-label="Observaciones:"
                            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                        </mat-form-field>
                      </div>
                      <div class="col-md-4" *ngIf="modeEditable">
                        <mat-form-field appearance="outline" class="profile-editor-page__field"
                          [class.profile-editor-page__field--hint]="esEstatusCerrado">
                          <mat-label>Estatus:</mat-label>
                          <mat-select formControlName="estatus">
                            <mat-option *ngFor="let option of estatusProyecto" [value]="option">{{ option
                              }}</mat-option>
                          </mat-select>
                          <mat-hint *ngIf="esEstatusCerrado">
                            Al cerrar el proyecto su equipo se libera; su historial de horas se conserva.
                          </mat-hint>
                          <mat-error *ngIf="
                          formStageEmployee
                            .get('estatus')
                            ?.hasError('required') &&
                          formStageEmployee.get('estatus')?.touched
                            ">
                            Campo requerido..
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-4" *ngIf="data.tipo === 'PROYECTO' || data.tipo === 'SERVICIO'">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>{{ data.tipo === "SERVICIO" ? "Responsable de servicio:" : "Lider de Proyecto:" }}</mat-label>
                          <mat-select formControlName="bossCtrl" [(ngModel)]="objectEtapa.id_lider"
                            (selectionChange)="selectedBoss($event.value)" title=" Campo requerido.. ">
                            <mat-option *ngFor="let item of listLider" [value]="item.idEmpleado">
                              {{ item.persona.nombreCompleto }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-4" *ngIf="data.tipo === 'SERVICIO'">
                        <mat-form-field appearance="outline" class="profile-editor-page__field profile-editor-page__field--hint">
                          <mat-label>Aplicación:</mat-label>
                          <input matInput formControlName="aplicacion" maxlength="60"
                            [(ngModel)]="data.aplicacion" aria-label="Aplicación:" />
                          <mat-hint>Nombre de la aplicación en donde se brindará el servicio</mat-hint>
                          <mat-error *ngIf="
                          formStageEmployee.get('aplicacion')?.hasError('pattern') &&
                          formStageEmployee.get('aplicacion')?.touched
                            ">
                            Solo se permiten letras, números, acentos, espacios, diagonales y guiones.</mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Registro de hrs -->
                      <div class="col-sm-4" *ngIf="data.tipo === 'PROYECTO' || data.tipo === 'SERVICIO'">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Horas totales<span *ngIf="data.tipo === 'PROYECTO'">*</span>:</mat-label>
                          <input matInput formControlName="horasProyecto" maxlength="5" soloNumero
                            [(ngModel)]="data.horasTotales" [disabled]="data.horasTotales !== null"
                            [attr.aria-label]="data.tipo === 'PROYECTO' ? 'Horas totales*:' : 'Horas totales:'" />
                          <mat-error *ngIf="
                          (formStageEmployee
                            .get('horasProyecto')
                            ?.hasError('required') ||
                            formStageEmployee
                              .get('horasProyecto')
                              ?.hasError('min')) &&
                          formStageEmployee.get('horasProyecto')?.touched
                            ">
                            Campo requerido..</mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-sm-4" *ngIf="data.tipo === 'PROYECTO'">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Horas Etc:</mat-label>
                          <input matInput [disabled]="data.horasEtc !== null" formControlName="horasEtc"
                            [(ngModel)]="data.horasEtc" soloNumero aria-label="Horas Etc:"
                            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)" />
                        </mat-form-field>
                      </div>

                      <!-- Presupuesto -->

                      <div class="col-sm-4" *ngIf="data.tipo === 'SERVICIO'">
                        <mat-form-field appearance="outline" class="profile-editor-page__field">
                          <mat-label>Tipo de servicio:</mat-label>
                          <mat-select selected="selected" formControlName="id_tipoServicio"
                            [(ngModel)]="data.id_tipoServicio">
                            <mat-option *ngFor="let item of tipoServicio" [value]="item.id">
                              {{ item.nombre }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="
                          formStageEmployee
                            .get('id_tipoServicio')
                            ?.hasError('required') &&
                          formStageEmployee.get('id_tipoServicio')?.touched
                            ">
                            Campo requerido..
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!-- Liga con Azure DevOps: sus work items se sugieren en Registrar tarea -->
                      <div class="col-md-8" *ngIf="data.tipo !== 'OPORTUNIDAD'">
                        <mat-form-field appearance="outline"
                          class="profile-editor-page__field profile-editor-page__field--hint">
                          <mat-label>Proyecto de Azure DevOps</mat-label>
                          <input matInput [formControl]="azureCtrl" [matAutocomplete]="autoAzure"
                            (focus)="cargarProyectosAzure()" (input)="filtraAzure($any($event.target).value)"
                            placeholder="Sin vincular" autocomplete="off"
                            aria-label="Proyecto de Azure DevOps" />
                          <button *ngIf="tieneLigaAzure" type="button" mat-icon-button matSuffix
                            class="project-admin-editor-page__field-suffix-action" matTooltip="Quitar la liga"
                            [matTooltipPosition]="'above'" aria-label="Quitar la liga con Azure DevOps"
                            (click)="desvincularAzure()">
                            <mat-icon>link_off</mat-icon>
                          </button>
                          <mat-autocomplete #autoAzure="matAutocomplete" [displayWith]="muestraProyectoAzure"
                            requireSelection (optionSelected)="alElegirAzure($event.option.value)"
                            (closed)="alCerrarAzure()">
                            <mat-option [value]="null">Sin vincular</mat-option>
                            <mat-option *ngIf="estadoAzure === 'cargando'" disabled>
                              Consultando Azure DevOps…
                            </mat-option>
                            <mat-option *ngFor="let proyectoAzure of proyectosAzureFiltrados; trackBy: trackProyectoAzure"
                              [value]="proyectoAzure">
                              {{ proyectoAzure.nombre }}
                            </mat-option>
                            <mat-option *ngIf="estadoAzure === 'listo' && proyectosAzureFiltrados.length === 0" disabled>
                              Ningún proyecto de Azure DevOps coincide con lo que escribiste.
                            </mat-option>
                          </mat-autocomplete>
                          <mat-hint>
                            <output *ngIf="estadoAzure === 'error'; else ayudaAzure" class="project-admin-editor-page__aviso">
                              No se pudo consultar Azure DevOps: revisa tu token de Azure en Ajustes. La liga actual se
                              conserva.
                            </output>
                            <ng-template #ayudaAzure>
                              {{
                              tieneLigaAzure
                              ? "Al registrar tareas de este proyecto se sugieren sus work items."
                              : "Opcional. Lígalo para sugerir sus work items al registrar tareas."
                              }}
                            </ng-template>
                          </mat-hint>
                        </mat-form-field>
                      </div>

                      <div class="col-sm-4" *ngIf="verGraficas && data.tipo === 'PROYECTO'">
                        <button type="button" class="project-admin-editor-page__metric-action"
                          (click)="consultaAvanceGrafica(data)">
                          <span class="project-admin-editor-page__metric-icon">
                            <mat-icon>assessment</mat-icon>
                          </span>
                          <span class="project-admin-editor-page__metric-copy">
                            <span class="project-admin-editor-page__metric-label">Seguimiento</span>
                            <strong>Ver avance grafico</strong>
                          </span>
                        </button>
                      </div>
                    </div>
                    <!-- end-content-panel-etapa -->
                    <mat-action-row class="project-admin-editor-page__section-footer">
                      <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                        [disabled]="!canAdvanceProjectStep" (click)="goToNextStep()">
                        Continuar a equipo
                      </button>
                    </mat-action-row>
                  </mat-expansion-panel>

              <mat-expansion-panel *ngIf="step === 2" expanded hideToggle
                class="project-admin-editor-page__wizard-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title> Documentos </mat-panel-title>
                      <mat-panel-description>
                        Archivos en repositorio
                        <mat-icon>folder</mat-icon>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div *ngIf="!data.tipoVobo">
                      <div class="project-admin-editor-page__upload-shell">
                        <div class="project-admin-editor-page__upload-header">
                          <div class="project-admin-editor-page__upload-copy">
                            <span class="project-admin-editor-page__upload-eyebrow">Carga de archivos</span>
                            <strong>VoBo del proyecto</strong>
                            <p>Adjunta la evidencia que respalda la aprobacion del proyecto o servicio.</p>
                          </div>
                          <div class="project-admin-editor-page__upload-actions">
                            <label for="nameFileArchivo"
                              class="app-form-btn app-form-btn--secondary app-form-btn--compact project-admin-editor-page__upload-action"
                              matTooltip="Agregar evidencia de VOBO">
                              <i class="material-icons">upload_file</i>
                              <span>Agregar</span>
                            </label>
                            <input type="file" id="nameFileArchivo" class="project-admin-editor-page__file-input"
                              accept=".eml,.msg,.pdf,.xls,.xlsx,.xlsm,.doc,.docx,.ppt,.pptx," mozdirectory directory
                              multiple (change)="cargarVobo()" />

                            <button *ngIf="listaVoboAgregarSelect.length > 0" type="button"
                              class="app-form-btn app-form-btn--secondary app-form-btn--compact project-admin-editor-page__upload-action project-admin-editor-page__upload-action--danger"
                              (click)="removerVobo()">
                              <i class="material-icons">delete_forever</i>
                              <span>Remover</span>
                            </button>
                          </div>
                        </div>

                        <div class="project-admin-editor-page__upload-list" *ngIf="listaArchivosAgregar.length > 0">
                          <mat-selection-list [(ngModel)]="listaEstimacionAgregarSelect"
                            (ngModelChange)="onNgModelChangeArchivo($event)" [ngModelOptions]="{ standalone: true }">
                            <mat-list-option *ngFor="let item of listaArchivosAgregar; index as i" [value]="item"
                              class="text-muted">
                              <p class="text-muted">{{ item.name }}</p>
                            </mat-list-option>
                          </mat-selection-list>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table table-shopping table-striped table-no-bordered">
                        <thead>
                          <tr>
                            <th class="fw-bold text-muted border-bottom primary" colspan="2">
                              Archivo
                            </th>
                            <th class="text-center fw-bold text-muted border-bottom primary">
                              Fecha
                            </th>
                            <th class="text-center text-muted fw-bold border-bottom primary" colspan="1">
                              Descargar
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="!data.archivos || data.archivos.length == 0">
                            <td class="text-center" colspan="4">
                              No existen archivos
                            </td>
                          </tr>
                          <tr *ngFor="let archivoGit of data.archivos">
                            <td class="pt-0 pb-0" matTooltip="{{ archivoGit.name }}" colspan="2">
                              <img class="img" alt="icono archivo" height="34px" [src]="
                                  archivoUtils.obtenerImagenTipoArchivo(
                                    archivoGit.type
                                  )
                                " />
                              {{ archivoGit.name }}
                            </td>
                            <td class="text-center pt-1 pb-1" matTooltip="Fecha de actualización">
                              {{
                              archivoGit.fecha == null
                              ? ""
                              : (archivoGit.fecha | date : "dd/MM/y, HH:mm")
                              }}
                            </td>
                            <td class="text-center pt-0 pb-0" colspan="1">
                              <button mat-raised-button class="btn btn-just-icon btn-link btn-icon-accions-file"
                                (click)="
                                  descargarArchivo(archivoGit.name, archivoGit.type)
                                " matTooltip="Descargar archivo">
                                <i class="material-icons">cloud_download</i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <mat-action-row class="project-admin-editor-page__section-footer">
                      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                        (click)="goToPreviousStep()">
                        Anterior
                      </button>
                      <button *ngIf="hasAdditionalScopeStep" type="button"
                        class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="goToNextStep()">
                        Continuar a alcances
                      </button>
                    </mat-action-row>
                  </mat-expansion-panel>

              <mat-expansion-panel *ngIf="step === 1" expanded hideToggle class="project-admin-editor-page__wizard-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title> Equipo de Trabajo </mat-panel-title>
                  <mat-panel-description>
                    Equipo de colaboradores que participar&aacute;n en el
                    proyecto.
                    <mat-icon>group</mat-icon>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <!-- content-panel-equipo-trabajo -->
                <app-add-emp-proy [recursosAsignadosDevelopers]="objectEtapa.colaboradores" (emmitResourcesDevelopers)="
                    resourcesSelectedDevelopers($event)
                  ">
                </app-add-emp-proy>

                <!-- Historial de quienes salieron del equipo: solo lectura, lo administra el backend -->
                <section *ngIf="integrantesLiberados.length > 0" class="table-page project-admin-editor-page__liberados"
                  aria-labelledby="titulo-integrantes-liberados">
                  <h3 id="titulo-integrantes-liberados" class="project-admin-editor-page__liberados-titulo">
                    Integrantes liberados ({{ integrantesLiberados.length }})
                  </h3>
                  <p class="project-admin-editor-page__liberados-ayuda">
                    Ya no forman parte del equipo; sus horas siguen en la bitácora y en los reportes del proyecto.
                  </p>
                  <div class="table-page__card">
                    <div class="table-page__table-wrap">
                      <table class="table-page__table">
                        <thead>
                          <tr>
                            <th scope="col">Nombre</th>
                            <th scope="col">Motivo</th>
                            <th scope="col">Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let liberado of integrantesLiberados">
                            <td>
                              <div class="table-page__cell-stack">
                                <span class="table-page__name">{{ liberado.nombre }}</span>
                                <span class="table-page__subtext">{{ liberado.detalle }}</span>
                              </div>
                            </td>
                            <td>
                              <span class="table-page__status-badge" [ngClass]="liberado.claseMotivo">
                                {{ liberado.motivo }}
                              </span>
                            </td>
                            <td>{{ liberado.fecha ? (liberado.fecha | date : "dd/MM/yyyy") : "—" }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>
                <!--end-content-panel-equipo-trabajo-->
                <mat-action-row class="project-admin-editor-page__section-footer">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                    (click)="goToPreviousStep()">
                    Anterior
                  </button>
                  <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                    (click)="goToNextStep()">
                    Continuar a documentos
                  </button>
                </mat-action-row>
              </mat-expansion-panel>

              <!-- Tabla para consultar/agregar los nuevos alcances-->
              <mat-expansion-panel *ngIf="step === 3 && nuevoAlcanceBtnOculto" expanded hideToggle
                class="project-admin-editor-page__wizard-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title> Nuevos Alcances </mat-panel-title>
                  <mat-panel-description>
                    Registro de nuevos alcances.
                    <mat-icon>category</mat-icon>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="table-responsive">
                  <table id="datatables"
                    class="table table-shopping table-striped table-no-bordered table-hover project-admin-editor-page__table"
                    datatable [dtOptions]="dt">
                    <thead>
                      <tr>
                        <th class="text-center">Fechas</th>
                        <th class="text-center">Horas autorizadas</th>
                        <th class="text-center">Presupuesto autorizado</th>
                        <th class="text-center">Detalles</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let alcance of alcances">
                        <td class="text-center">
                          {{ formatDate(alcance.fechaInicio) }}/{{
                          formatDate(alcance.fechaFin)
                          }}
                        </td>
                        <td class="text-center">{{ alcance.horasTotales }}</td>
                        <td class="text-center">
                          {{ alcance.presupuestoAutorizado }}
                        </td>
                        <td class="text-center">
                          <button mat-raised-button type="button" class="btn btn-info btn-round btn-fab"
                            (click)="abrirModalParaAgregarNuevoAlcance(alcance)">
                            <i class="material-icons">info</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <mat-action-row class="project-admin-editor-page__section-footer">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                    (click)="goToPreviousStep()">
                    Anterior
                  </button>
                </mat-action-row>
              </mat-expansion-panel>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</div>
